import './toolFlipCards.css';
import React, { useState } from 'react';

import IconsBackground from '../../assets/icons/iconsBackground/iconsBackground';
import FlipButton from '../flipButton/flipButton';
import Button from '../button/button';
import PlansFlipButton from '../plansFlipButton/plansFlipButton';
import SpaceBar from '../spacerBars/spaceBar';
import FlipIcon from '../../assets/icons/flipIcon/flipIcon';

export default function ToolFlipCards({
    flipQuantity,
    cardSize,
    iconOne, iconTwo, iconThree, 
    titleOne, titleTwo, titleThree, 
    barBool, barCenter, barWidth, barOffset, barThick, barColor, 
    subTitleOne, subTitleTwo, subTitleThree, 
    headerOne, headerTwo, headerThree, 
    textContentTopOne, textContentTopTwo, textContentTopThree, 
    bulletPointsOne, bulletPointsTwo, bulletPointsThree, 
    textContentBottomOne, textContentBottomTwo, textContentBottomThree, 
    button, flipButton, plansFlipButton, 
    isMobile, signUpClass}){

        const [flipCardIndex, setFlipCardIndex] = useState(0)

        let flipCardTitles = [];
        flipQuantity ? flipCardTitles = [titleOne, titleTwo, titleThree] : flipCardTitles = [titleOne, titleTwo];
          
        const flipCardIcons  = flipQuantity ? [iconOne, iconTwo, iconThree] : [iconOne, iconTwo];

        const flipCardBulletPoints = flipQuantity ? [bulletPointsOne, bulletPointsTwo, bulletPointsThree] : [bulletPointsOne, bulletPointsTwo];

        const flipCardbottomText = flipQuantity ? [textContentBottomOne, textContentBottomTwo, textContentBottomThree] : [textContentBottomOne, textContentBottomTwo];

        const flipCardTopText = [textContentTopOne, textContentTopTwo];

        const flipCardSubTitle = [subTitleOne, subTitleTwo];

        const flipCardBottomTextTwo = [textContentBottomOne, textContentBottomTwo,]

            const clickRight = () => {flipQuantity ? setFlipCardIndex((flipCardIndex + 1) % 3) : setFlipCardIndex((flipCardIndex + 1) % 2);}

            const clickLeft = () => { flipQuantity ? setFlipCardIndex((flipCardIndex - 1 + 3) % 3) : setFlipCardIndex((flipCardIndex - 1 + 2) % 2);}

    return(
        <div>
            {flipQuantity ? 

            <div>
                <div className="triple-icons-container">
                    <div className="tool-cards-icon tool-cards-icon-a wifi-globe-selector custom-reports-selector">{flipCardIcons[(flipCardIndex -1 + 3) % 3]}<IconsBackground/></div>
                    <div className="tool-cards-icon tool-cards-icon-b wifi-globe-selector custom-reports-selector">{flipCardIcons[flipCardIndex]}<IconsBackground/></div>
                    <div className="tool-cards-icon tool-cards-icon-c wifi-globe-selector custom-reports-selector">{flipCardIcons[(flipCardIndex + 1) % 3]}<IconsBackground/></div>
                </div>
                <div>
                    <div className="tool-cards-body" style={{width: `${cardSize ? '36rem' : '42rem'}`}}>
                        
                        <div className="triple-flip-arrows"><FlipIcon point={true} onClick={clickLeft}/><FlipIcon point={false} onClick={clickRight}/></div>
                        <h2 className={`${cardSize ? '' : 'tool-cards-body-title-large'}`}>{flipCardTitles[flipCardIndex]}</h2>
                        {barBool && <SpaceBar width={barWidth} center={barCenter} thick={barThick} color={barColor} offset={barOffset}/>}
                        <h4 className={'tool-cards-body-sub-title-large'}>{subTitleOne}</h4>
                        <p className="tool-card-top-text">{textContentTopOne}</p>
                        {flipCardBulletPoints[flipCardIndex]?.map((text, index) => (
                            <div className="tool-card-bullet-points" style={{ width: `${cardSize ? '36rem' : '42rem'}`, borderRadius: `${cardSize ? '4rem' : '10rem'}`}}>
                                <div className="expensible-bullet-point"></div>
                                <p key={index}>{text}</p>
                            </div>
                        ))}
                        <p className="textContentBottom">{flipCardbottomText[flipCardIndex]}</p> 
                        <div className="flip-cards-button-flipper"><FlipButton onClick={clickRight}/></div>
                    </div>
                </div> 
            </div>
            
            :

            <div className={signUpClass}>
                <div className={'double-icons-container'}>
                    <div className="tool-cards-icon double-card-icon-active">{flipCardIcons[flipCardIndex]}<IconsBackground/></div>
                    <div className="tool-cards-icon double-card-icon-inactive">{flipCardIcons[(flipCardIndex + 1) % 2]}<IconsBackground/></div>
                </div>
                <div>
                    <div className="tool-cards-body" style={{width: `${cardSize ? '36rem' : '42rem'}`, paddingTop: `${cardSize ? '8rem' : '0rem'}`}}>
                        {cardSize ? <div className="double-flip-arrows"><FlipIcon point={true} onClick={clickLeft}/><FlipIcon point={false} onClick={clickRight}/></div> : ''}
                        <h2 className={`${cardSize ? 'tool-cards-body-title-large double-card-title-small' : 'tool-cards-body-title-large double-card-title-large'}`}>{flipCardTitles[flipCardIndex]}</h2>
                        {barBool && <SpaceBar width={barWidth} center={barCenter} thick={barThick} color={barColor} offset={barOffset}/>}
                        <h4 className={'tool-cards-body-sub-title-large'}>{subTitleOne}</h4>
                        <p className="tool-card-top-text">{textContentTopOne}</p>
                        {flipCardBulletPoints[flipCardIndex]?.map((text, index) => (
                            <div className="tool-card-bullet-points" style={{ width: `${cardSize ? '36rem' : '42rem'}`, borderRadius: `${cardSize ? '10rem' : '10rem'}`}}>
                                <div className="expensible-bullet-point"></div>
                                <p key={index}>{text}</p>
                            </div>
                        ))}
                        <p className="textContentBottom">{flipCardBottomTextTwo[flipCardIndex]}</p>
                        {isMobile ? 

                        <div>
                            <div className="flip-cards-button-flipper"><FlipButton onClick={clickRight}/></div>
                            <div className="tool-cards-button"><Button buttonName={button} /></div> 
                        </div>

                        : 
                        
                        <PlansFlipButton onClick={clickRight}/>}
                    </div>
                    
                </div> 
            </div>

            }
        </div>
    )
}